module.exports = __webpack_public_path__ + "img/sleep.eaab33ad.png";